var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12","sm":"6","lg":"6"}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{staticStyle:{"height":"100%"},attrs:{"elevation":(hover ? 12 : 2)},on:{"click":_vm.openLink}},[_c('v-img',{attrs:{"src":_vm.image}})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }